import React, { useEffect, useState } from 'react';
import { useFetch } from '../../../hooks/useFetch';
import { Pagination } from '../../pagination';
import { useAuthToken } from '../../../hooks/useAuthToken';
import { apiConfig } from '../../../api/apiConfig';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Filters } from '../filters/Filters';
const landingImages = require.context('../../../assets/images', true);
/**
 * Creado por Equilibrio Agency 2022<br>
 * Listado sección Reportes
 * @interface ReportsCourseUsersSection
 */
export const ReportsCourseUsersSection = () => {
  const { studyId } = useParams();
  const navigator = useNavigate();
  const [users, setUsers] = useState([]);
  const [usersFull, setUsersFull] = useState([]);
  const [total, setTotal] = useState(1);
  const [data, handleFetch] = useFetch();
  const { authToken } = useAuthToken(true);
  // Consulta de endpoint reportes de pagos
  useEffect(() => {
    let filterstudyid = `&course=` + studyId;
    let filtercompany = '&companyId=' + apiConfig.company;
    const response = handleFetch({
      url: `bo/reportscourses?${filterstudyid}${filtercompany}`,
      method: 'GET',
      headers: { Authorization: `Bearer ${authToken}` },
    });
    response.then(
      (r) => {
        if (r?.data.length === 0) {
          navigator('/admin/dashboardreport');
        }
        setUsers(r?.data);
        setTotal(r?.total);
      },
      (error) => {
        console.log(error.errors);
      }
    );
    const responsefull = handleFetch({
      url: `bo/reportscourses?$limit=50000${filterstudyid}${filtercompany}`,
      method: 'GET',
      headers: { Authorization: `Bearer ${authToken}` },
    });
    responsefull.then(
      (r) => {
        setUsersFull(r?.data);
      },
      (error) => {
        console.log(error.errors);
      }
    );
  }, [total]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    let filterstudyid = `&course=` + studyId;
    let filtercompany = '&companyId=' + apiConfig.company;
    const response = handleFetch({
      url: `bo/reportscourses?${filterstudyid}${filtercompany}`,
      method: 'GET',
      headers: { Authorization: `Bearer ${authToken}` },
    });
    response.then(
      (r) => {
        setUsers(r?.data);
        setTotal(r.total);
      },
      (error) => {
        console.log(error.errors);
      }
    );
    const responsefull = handleFetch({
      url: `bo/reportscourses?$limit=50000${filterstudyid}${filtercompany}`,
      method: 'GET',
      headers: { Authorization: `Bearer ${authToken}` },
    });
    responsefull.then(
      (r) => {
        setUsersFull(r?.data);
      },
      (error) => {
        console.log(error.errors);
      }
    );
  };
  return (
    <>
      <Link to={`/admin/dashboardreport`} className="px-4 px-sm-5 text_primary fw-bold">
        Volver a Dashboard
      </Link>
      <div className="row justify-content-center mb-4">
        <div className="col-10">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <h1
                style={{
                  fontSize: '36px',
                  fontWeight: '700',
                  lineHeight: '46.8px',
                  letterSpacing: '-1%',
                }}
              >
                Reporte de cursos
              </h1>
            </div>
          </div>
          <div className="row justify-content-center" style={{ marginTop: '30px' }}>
            <Filters
              downloadCSV={true}
              filename={'listreports.csv'}
              onSubmit={handleSubmit}
              data={usersFull}
            ></Filters>
          </div>
          <div className="row justify-content-center">
            <div className="" style={{ width: '90%', marginTop: '17px', overflowX: 'auto' }}>
              {data.loading ? <Loading /> : <UsersTable users={users} total={total} />}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
/**
 * Creado por Equilibrio Agency 2022<br>
 * Función para listar reportes
 * @param {JSON} users Información de usuarios
 * @param {string} total Cantidad total de usuarios
 * @function UsersTable
 */
const UsersTable = ({ users, total }) => {
  const [page, setPage] = useState(0);
  // Header para listado de reportes
  const headers = [
    {
      name: 'NOMBRE COMPLETO',
      sort_name: 'title',
      width: '25%',
    },
    {
      name: 'CURSO REALIZADO',
      sort_name: 'enabled',
      width: '25%',
    },
    {
      name: 'COMPAÑIA B2B',
      sort_name: 'b2bcompany',
      width: '15%',
    },
    {
      name: 'PORCENTAJE',
      sort_name: 'percentaje',
      width: '10%',
    },
    {
      name: 'FECHA INICIO',
      sort_name: 'amount',
      width: '10%',
    },
    {
      name: 'TIPO DE USUARIO',
      sort_name: 'lastlogin',
      width: '15%',
      align: 'center',
    },
  ];

  const [usersSorted, setUsersSorted] = useState(users);
  const [, setTotalSorted] = useState(total);
  const [, setUserHovered] = useState(Array(users.length).fill(false));

  useEffect(() => {
    setUsersSorted(users);
    setTotalSorted(total);
  }, [users, total]);

  const resetState = () => {
    setUserHovered(Array(users.length).fill(false));
  };

  const handleActiveRow = (index) => {
    let auxArray = Array(users.length).fill(false);
    auxArray[index] = true;
    setUserHovered(auxArray);
  };

  const [, handleFetch] = useFetch();
  const { authToken } = useAuthToken(true);
  // Handle para paginación
  const handlePageClick = (event) => {
    let result = 50 * event.selected;
    setPage(event.selected);
    const response = handleFetch({
      url: `bo/usercourses?$skip=${result}`,
      method: 'GET',
      headers: { Authorization: `Bearer ${authToken}` },
    });
    response.then(
      (r) => {
        setUsersSorted(r?.data);
        setTotalSorted(r.total);
      },
      (error) => {
        console.log(error.errors);
      }
    );
  };

  const usertype = [
    {
      id: 1,
      name: 'Público General',
    },
    {
      id: 2,
      name: 'Estudiante Eanista',
    },
    {
      id: 3,
      name: 'Docente de Planta',
    },
    {
      id: 4,
      name: 'Docente de Cátedra',
    },
    {
      id: 5,
      name: 'Colaborador',
    },
    {
      id: 6,
      name: 'Egresado',
    },
  ];
  return (
    <>
      <table className="UserAdmin__table">
        <thead className="UserAdmin__table-header" style={{ height: '52px' }}>
          <tr style={{ cursor: 'pointer' }}>
            {headers.map((header, index) => {
              return (
                <th
                  key={index}
                  className="overflow"
                  style={{
                    width: header.width,
                    paddingLeft: '16px',
                    textAlign: header.align ? header.align : 'left',
                  }}
                >
                  {header.name}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {usersSorted.length != 0 ? (
            usersSorted.map((user, index) => {
              const typeUserName = usertype.find(
                (item) => parseInt(item.id) == user?.['webuser.type']
              );
              return (
                <tr
                  onMouseLeave={resetState}
                  onMouseEnter={() => {
                    handleActiveRow(index);
                  }}
                  className={`UserAdmin__table-row ${index % 2 === 0 ? 'UserAdmin__table-pair-row' : 'UserAdmin__table-odd-row'}`}
                  key={index}
                >
                  <td className="overflow" style={{ paddingLeft: '16px' }}>
                    {user?.['webuser.name']} {user?.['webuser.lastname']}
                  </td>
                  <td className="overflow UserAdmin__table-td" style={{ paddingLeft: '16px' }}>
                    {user?.['course.title']}
                  </td>
                  <td className="overflow" style={{ textAlign: 'center' }}>
                    {user?.['webuser.companiesb2b.name'] || user?.['webuser.companyId']}
                  </td>
                  <td className="overflow" style={{ textAlign: 'center' }}>
                    {user?.progress}%
                  </td>
                  <td className="overflow" style={{ textAlign: 'center' }}>
                    {new Date(user.createdAt).toISOString().split('T')[0]}
                  </td>
                  <td className="overflow" style={{ textAlign: 'center', paddingLeft: '16px' }}>
                    {typeUserName?.name}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="6" style={{ padding: '16px', textAlign: 'center' }}>
                <strong>No se encontraron registros</strong>
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <Pagination
        itemsPerPage={50}
        totalElements={total}
        onChangePage={handlePageClick}
        forcePage={page}
      />
    </>
  );
};

/**
 * Creado por Equilibrio Agency 2022<br>
 * Función Loading
 * @function Loading
 */
const Loading = () => {
  const loadingImage = landingImages('./icons/loading_spin_ean.svg');
  return (
    <div className="d-flex justify-content-center" style={{ minHeight: '300px' }}>
      <div className="row text-center position-absolute justify-content-center">
        <img alt="Loader" src={loadingImage} />
      </div>
    </div>
  );
};
